import { ReservationInputComponentModule } from '@b2b/common/components/reservation-input';
import { PaymentProcessError } from '@b2b/common/directives/payment/types';
import { Notice, NoticeFactory } from '@b2b/common/factories/notice';
import { ThemesData } from '@b2b/common/resolvers';
import { safeApply } from '@b2b/common/rxjs';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { LocationService, LocationServiceModule } from '@b2b/common/services/address/location.service';
import { ApiService } from '@b2b/common/services/api/types';
import {
  CheckoutProcessService,
  CheckoutProcessServiceModule,
} from '@b2b/common/services/checkout/checkoutProcess.service';
import { OrderBookingCreateData, SecureOrderBookingCreateProps } from '@b2b/common/services/checkout/rebook.types';
import { isACMECORSCheckoutError } from '@b2b/common/services/checkout/types';
import { PaymentService, PaymentServiceModule } from '@b2b/common/services/payment/payment.service';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEResponse, TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, ISCEService, IScope, ITimeoutService } from 'angular';

export const ProgramsListAdminBookingControllerModule = angular
  .module('acme.view.application.programs.list.admin.booking.controllers', [
    uiRouter,
    'angularUUID2',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.validate',
    'acme.common.service.order',
    'acme.common.service.helpers',
    'acme.common.service.themesHelper',
    'acme.common.service.permissions',
    'acme.common.factory.notice',
    'acme.common.filter.saleChannel',
    'acme.common.service.userPreferences',
    ReservationInputComponentModule,
    CheckoutProcessServiceModule,
    LocationServiceModule,
    PaymentServiceModule,
    AddressServiceModule,
  ])

  .controller('ProgramsListAdminBookingController', [
    '$scope',
    '$sce',
    '$state',
    '$filter',
    '$timeout',
    'uuid2',
    'ApiService',
    'CalendarService',
    'ValidateService',
    'OrderService',
    'NoticeFactory',
    'HelpersService',
    'ThemesHelperService',
    'PermissionsService',
    'EventData',
    'ThemesData',
    'UserPreferencesService',
    'CheckoutProcessService',
    'LocationService',
    'PaymentService',
    'AddressService',
    function (
      $scope: IScope & { programsListAdminBooking: TODO; noticeTimer: TODO; stateTimer: TODO },
      $sce: ISCEService,
      $state: StateService,
      $filter: IFilterService,
      $timeout: ITimeoutService,
      uuid2: TODO,
      ApiService: ApiService,
      CalendarService: TODO,
      ValidateService: TODO,
      OrderService: TODO,
      NoticeFactory: NoticeFactory,
      HelpersService: TODO,
      ThemesHelperService: ThemesHelperService,
      PermissionsService: PermissionsService,
      EventData: TODO,
      ThemesData: { data: ACMEResponse<ThemesData> },
      UserPreferencesService: TODO,
      CheckoutProcessService: CheckoutProcessService,
      LocationService: LocationService,
      paymentService: PaymentService,
      addressService: AddressService
    ) {
      const ctrl = {
        requiresCardData: false,

        model: {
          notes: '',
          orderId: 0,
          rebookItems: [],
          incidentReasonCode: 'Rebook Event',
          noEmail: false,
          sendEmailToAll: false,
          eventRebookFeeCounts: [],
          payment: {},
          email: '',
        } as TODO,

        requestUUID: false as string | false,

        themes: {},

        eventDetails: {
          columns: 1,
          columnWidth: 6,
          data: 'programsListAdminBooking.event',
          sorting: false,
          include: ['name', 'startDate', 'startHour'],
        },

        channelDetails: {
          columns: 2,
          columnWidth: 3,
          data: 'programsListAdminBooking.salesChannels',
          sorting: false,
          include: ['online', 'customerRep', 'pointOfSale', 'manualEntry', 'reseller'],
          mappings: {
            online: 'Web',
            customerRep: 'Customer Representative',
          },
        },

        orderDetails: {
          columns: 3,
          data: 'programsListAdminBooking.currentOrder',
          sorting: true,
          include: [
            'orderNumber',
            'phoneNumber',
            'email',
            'contactFirstName',
            'contactLastName',
            'accountName',
            'companyName',
            'membershipId',
          ],
        },

        emailOptions: false as TODO,
        emailOption: '',

        loop: {} as TODO,
        autoFee: {} as TODO,
        sendEmail: true,
        email: '',
        isDiscounted: false,
        subTotal: 0,
        event: {} as TODO,
        eventInitial: {} as TODO,
        summary: {} as TODO,
        orders: [] as TODO[],
        orderEvents: {} as TODO,
        rebookItems: {} as TODO,
        eventRebookFees: {} as TODO,
        rebookPersonTypes: {} as TODO,
        salesChannels: {} as TODO,
        currentOrder: {} as TODO,
        order: {} as TODO,
        notice: {} as Notice,
        mode: 'booking',

        showEmpty: false,
        rebookTimer: false,
        orderLoading: false,
        orderLoadingId: 0,
        ordersLoading: false,
        searchQuery: '',
        lastSearchQuery: '',

        paymentMethods: ['CreditCard'],
        payment: {} as TODO,
        getItemType: OrderService.getItemType,
        isProcessing: false,
        enableCSRToggle: false,
        dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        validateEmail: true,
        hasEmailError: false,

        isEnabledCORSCheckout: false,
        corsCheckoutCreditCardMessage: `Payment will be securely collected when you select "Take Payment & Rebook Order"`,

        init: function () {
          paymentService.processData$
            .pipe(
              safeApply($scope, {
                next: ({ chargeAmount, paymentMethod }) => {
                  ctrl.requiresCardData = paymentMethod === 'CreditCard' && chargeAmount > 0;
                },
              })
            )
            .subscribe();

          if (PermissionsService.check('CSR')) {
            ctrl.enableCSRToggle = true;
          }
          $scope.$emit('Application::contentTitleChange', {
            title: 'Re-Book Order',
            buttonLeft: {
              label: 'Cancel',
              action: () => {
                ctrl.cancel();
              },
            },
          });

          if (EventData && EventData.data.success) {
            ctrl.success.init(EventData);
            ctrl.eventInitial = Object.assign({}, ctrl.event);
          } else {
            ctrl.error.init(EventData);
          }

          ThemesHelperService.resetModel();

          if (ThemesData && ThemesData.data.success) {
            ctrl.initThemes(ThemesData);
          }

          ctrl.notice = new NoticeFactory();

          if ($state.params && $state.params.orderId && $state.params.orderId.length > 0) {
            ctrl.searchQuery = $state.params.orderId;
            ctrl.searchOrders();
          }

          $scope.$on('Payment::Complete', ctrl.onPaymentComplete);
          $scope.$on('Payment::Error', ctrl.onPaymentError);
        },

        initThemes: function (response) {
          ThemesHelperService.setModel(response.data.payload);
          CheckoutProcessService.initACMECheckout();
          ctrl.themes = {
            policyTerms: $sce.trustAsHtml(ThemesHelperService.getHTMLVariable('checkout-process-page-terms')),
          };

          ctrl.isEnabledCORSCheckout = ThemesHelperService.getFeatureFlag('enableCORSCheckout');
        },

        isEmail: function () {
          return ValidateService.validate([{ email: ctrl.searchQuery }]);
        },

        isMode: function (mode) {
          return ctrl.mode === mode;
        },

        resetModel: function () {
          ctrl.model.notes = '';
          ctrl.model.orderId = 0;
          ctrl.model.rebookItems = [];
          ctrl.model.incidentReasonCode = 'Rebook Event';
          ctrl.model.noEmail = false;
          ctrl.model.sendEmailToAll = false;
          ctrl.model.eventRebookFeeCounts = [];
          ctrl.model.payment = {};
          ctrl.model.address = {};
          ctrl.sendEmail = true;
          ctrl.email = '';
        },

        resetOrder: function () {
          ctrl.currentOrder = {};
          ctrl.orders = [];
        },

        viewOrder: function (id) {
          ctrl.getOrder(id);
        },

        shortDate: function (date) {
          return $filter('date')(CalendarService.parseDate(date), 'M/d/yy');
        },

        getOrder: function (id) {
          ctrl.orderLoadingId = id;

          if (id !== ctrl.currentOrder.orderId) {
            ctrl.rebookPersonTypes = {};
            ctrl.orderLoading = true;
            ctrl.notice.hideErrorMessages();
            ctrl.notice.hideSuccessMessages();
            ApiService.orders.willCall.order(id).then(ctrl.success.getOrder, ctrl.error.getOrder);
          }
        },

        getRebookFees: function () {
          const ids: string[] = [];

          for (const id in ctrl.orderEvents) {
            if (ctrl.orderEvents.hasOwnProperty(id)) {
              ids.push(id);
            }
          }

          ApiService.program.instances
            .rebookFees(ids.join(','))
            .then(ctrl.success.getRebookFees, ctrl.error.getRebookFees);
        },

        getAccountDiscountedEvent: function (accountId) {
          ApiService.partners.reseller
            .event({ accountId: accountId, eventId: ctrl.event.id })
            .then(ctrl.success.getDiscountedEvent, ctrl.error.getDiscountedEvent);
        },

        getPayments: function (accountId) {
          ApiService.partners.payments.account(accountId).then(ctrl.success.getPayments, ctrl.error.getPayments);
        },

        getMembershipDiscountedEvent: function (membershipId) {
          ApiService.program.instances
            .discount({ membershipId: membershipId, id: ctrl.event.id })
            .then(ctrl.success.getDiscountedEvent, ctrl.error.getDiscountedEvent);
        },

        getOrderEventDetails: function (orderId) {
          ApiService.orders.events(orderId).then(ctrl.success.getOrderEventDetails, ctrl.error.getOrderEventDetails);
        },

        getDuplicateOrder: function () {
          const uuid = ctrl.requestUUID ? ctrl.requestUUID : '';

          ApiService.system
            .uuidObjectRegistry({ uuid })
            .then(ctrl.success.getDuplicateOrder, ctrl.error.getDuplicateOrder);
        },

        getCouponsForEvent: function () {
          ApiService.event.coupon
            .priceLists({ eventIds: ctrl.event.id, validate: '1' })
            .then(ctrl.success.getCouponsForEvent, ctrl.error.getCouponsForEvent);
        },

        findEventPersonType: function (type, list) {
          list = list || ctrl.event.priceList.prices;
          let r = 0;

          for (let i = 0, ii = list.length; i < ii; i++) {
            if (list[i].personType.name === type) {
              r = i;
              break;
            }
          }

          return r;
        },

        getCouponDiscountForRebookType: function (ticket, rebookItemKey) {
          let r = '';
          const couponCode = ticket.couponDetail && ticket.couponDetail.code;
          const rebookItem = ctrl.rebookPersonTypes[rebookItemKey];
          const filteredItems = ctrl.event.coupons.filter(function (item) {
            return item.couponCode === couponCode;
          });

          if (filteredItems.length && rebookItem) {
            const id = rebookItem.personType.id;

            for (let i = 0, ii = filteredItems[0].priceList.length; i < ii; i++) {
              if (filteredItems[0].priceList[i].personTypeId === id) {
                r = filteredItems[0].priceList[i].discountedPrice;
                break;
              }
            }
          }

          return r;
        },

        getCouponCodeForRebookType: function (ticket, rebookItemKey) {
          let r = '';
          const couponCode = ticket.couponDetail && ticket.couponDetail.code;
          const rebookItem = ctrl.rebookPersonTypes[rebookItemKey];
          let filteredItems;

          if (ctrl.event.coupons instanceof Array) {
            filteredItems = ctrl.event.coupons.filter(function (item) {
              return item.couponCode === couponCode;
            });
          }

          if (filteredItems && filteredItems.length && rebookItem) {
            const id = rebookItem.personType.id;

            for (let i = 0, ii = filteredItems[0].priceList.length; i < ii; i++) {
              if (filteredItems[0].priceList[i].personTypeId === id) {
                r = couponCode;
                break;
              }
            }
          }

          return r;
        },

        findEventInventoryType: function (name, list) {
          list = list || ctrl.event.addOns.inventoryAddOns;
          let r = 0;

          if (ctrl.event.hasOwnProperty('addOns') && list instanceof Array) {
            for (let i = 0, ii = list.length; i < ii; i++) {
              if (list[i].name === name) {
                r = i;
                break;
              }
            }
          }

          return r;
        },

        findItemTypeById: function (items, id, orderItemId) {
          let r = false;

          for (let i = 0, ii = items.length; i < ii; i++) {
            //intentionally using == here and not ===
            if (orderItemId) {
              if (items[i].orderItemId == orderItemId && !ctrl.isMembershipConversion(items[i])) {
                r = items[i];
                break;
              }
            } else {
              if (items[i].itemTypeId == id && !ctrl.isMembershipConversion(items[i])) {
                r = items[i];
                break;
              }
            }
          }

          return r;
        },

        findEventById: function (events, id) {
          let r = false;

          for (let i = 0, ii = events.length; i < ii; i++) {
            //intentionally using == here and not ===
            if (events[i].eventId == id) {
              r = events[i];
              break;
            }
          }

          return r;
        },

        hasName: function (order) {
          return order.contactFirstName || order.contactLastName;
        },

        isCheckedIn: function () {
          return ctrl.currentOrder.checkedInStatus === 'CheckedIn';
        },

        hasOrders: function (id) {
          return ctrl.orders instanceof Array && ctrl.orders.length > 0;
        },

        hasCurrentOrder: function () {
          return ctrl.currentOrder.orderNumber;
        },

        checkOrders: function () {
          if (ctrl.orders instanceof Array && ctrl.orders.length > 0) {
            ctrl.showEmpty = false;

            if (ctrl.orders.length === 1) {
              ctrl.viewOrder(ctrl.orders[0].orderId);
            }
          } else {
            ctrl.showEmpty = true;
          }
        },

        updateRebookItems: function () {
          //TODO: check if rebook Quantity is > 0 before adding to rebookItems list
          var type, itemId, event, couponDiscount, item;

          for (type in ctrl.rebookPersonTypes) {
            if (ctrl.rebookPersonTypes.hasOwnProperty(type)) {
              itemId = type.split('-');
              event = ctrl.findEventById(ctrl.currentOrder.eventItems, itemId[1]);
              item = ctrl.findItemTypeById(event.items || [], itemId[2], itemId[3]) || {};

              if (item.itemType && ctrl.isInventoryItemType(item.itemType)) {
                ctrl.rebookItems['item-' + itemId[1] + '-' + itemId[2] + '-' + itemId[3]] = {
                  orderItemId: item.orderItemId,
                  rebookQuantity: item.rebookQuantity,
                  rebookToEventId: ctrl.event.id,
                  incidentReasonCode: ctrl.model.incidentReasonCode,
                  itemType: item.itemType,
                  itemTypeId: ctrl.rebookPersonTypes[type].id,
                  itemTypeName: ctrl.rebookPersonTypes[type].name,
                };
              } else if (item.itemType && ctrl.isEventItemType(item.itemType)) {
                ctrl.rebookItems['item-' + itemId[1] + '-' + itemId[2] + '-' + itemId[3]] = {
                  orderItemId: item.orderItemId,
                  rebookQuantity: item.rebookQuantity,
                  rebookToEventId: ctrl.event.id,
                  incidentReasonCode: ctrl.model.incidentReasonCode,
                  itemType: item.itemType,
                  itemTypeId: ctrl.rebookPersonTypes[type].personType.id,
                  itemTypeName: ctrl.rebookPersonTypes[type].personType.name,
                  couponCode: ctrl.getCouponCodeForRebookType(item, type) || null,
                };
              }
            }
          }
        },

        isFeeItemType: function (type) {
          return type === 'RebookingFee';
        },

        isEventItemType: function (type) {
          return type === 'Event' || type === 'Combo';
        },

        isMembershipItemType: function (type) {
          return type && type.toLowerCase().indexOf('membership') > -1;
        },

        isInventoryItemType: function (type) {
          return type === 'Inventory' || type === 'ComboInventory';
        },

        eventHasAddOns: function () {
          return ctrl.event.hasOwnProperty('addOns') && ctrl.event.addOns.inventoryAddOns instanceof Array;
        },

        toggleAutoFee: function (eventId) {
          ctrl.autoFee[eventId] = !ctrl.autoFee[eventId];

          if (ctrl.autoFee[eventId]) {
            ctrl.applyAutoFees();
          }
        },

        applyFees: function (eventId) {
          let quantity;
          let tickets: TODO[] = [];
          const events = ctrl.currentOrder.eventItems;

          if (!ctrl.autoFee[eventId]) {
            for (let i = 0, ii = events.length; i < ii; i++) {
              if (eventId === events[i].eventId) {
                quantity = 0;
                tickets = events[i].items;
                for (let j = 0, jj = tickets.length; j < jj; j++) {
                  quantity += tickets[j].rebookQuantity || 0;
                }
                // Do not allow manual fee to exceed total quantity of rebooked tickets

                if (quantity < ctrl.eventRebookFees[eventId].quantity) {
                  ctrl.eventRebookFees[eventId].quantity = quantity;
                }
                break;
              }
            }

            ctrl.eventRebookFees[eventId].total =
              ctrl.eventRebookFees[eventId].quantity * ctrl.eventRebookFees[eventId].rebookingFee;
          }
        },

        applyAutoFees: function () {
          let quantity;
          let tickets: TODO[] = [];
          const events = ctrl.currentOrder.eventItems;

          for (let i = 0, ii = events.length; i < ii; i++) {
            quantity = 0;
            tickets = events[i].items;
            for (let j = 0, jj = tickets.length; j < jj; j++) {
              if (ctrl.isEventItemType(tickets[j].itemType)) {
                quantity += tickets[j].rebookQuantity;
              }
            }
            if (ctrl.eventRebookFees.hasOwnProperty(events[i].eventId)) {
              ctrl.eventRebookFees[events[i].eventId].quantity = quantity;
              ctrl.eventRebookFees[events[i].eventId].total =
                ctrl.eventRebookFees[events[i].eventId].quantity * ctrl.eventRebookFees[events[i].eventId].rebookingFee;
            }
          }
        },

        findOrderItem: function (orderItemId) {
          let r: TODO = false;
          const events = ctrl.currentOrder.eventItems;

          for (let i = 0, ii = events.length; i < ii; i++) {
            const tickets: TODO[] = events[i].items;
            for (let j = 0, jj = tickets.length; j < jj; j++) {
              if (tickets[j].orderItemId == orderItemId) {
                r = {
                  item: tickets[j],
                  index: {
                    event: i,
                    item: j,
                  },
                };
                break;
              }
            }
          }

          return r;
        },

        findRebookFees: function (orderItemId) {
          let fee = 0;
          const orderItem = ctrl.findOrderItem(orderItemId);

          for (let i = 0, ii = ctrl.summary.rebookEventFees.length; i < ii; i++) {
            if (
              ctrl.summary.rebookEventFees[i].eventId === ctrl.currentOrder.eventItems[orderItem.index.event].eventId
            ) {
              fee += HelpersService.currencyFloatToInteger(ctrl.summary.rebookEventFees[i].fee);
            }
          }

          return HelpersService.integerToCurrencyFloat(fee);
        },

        searchOrders: function () {
          var props: TODO = {};

          if (ctrl.searchQuery.length >= 3) {
            ctrl.lastSearchQuery = ctrl.searchQuery;
            ctrl.ordersLoading = true;
            if (ctrl.isEmail()) {
              props.email = encodeURIComponent(ctrl.searchQuery);
            } else {
              props.orderNumber = ctrl.searchQuery;
            }
            ctrl.resetOrder();
            ctrl.mode = 'booking';
            ApiService.orders.willCall.find(props).then(ctrl.success.searchOrders, ctrl.error.searchOrders);
          }
        },

        validateTicketQuantity: function (ticket) {
          if (!(ticket instanceof Array)) {
            ticket = [];
          }
          return ticket.some(function (list) {
            return list.items.some(function (item) {
              return item.rebookQuantity > 0;
            });
          });
        },

        updateQuantity: function (ticket, quantity, event) {
          ticket.rebookQuantity = quantity;
          ctrl.validateTicket(ticket, event.eventId, ticket.ticketTypeId, ticket.orderItemId);
        },

        onReservationSuccess: function (price) {
          var _reserved = price.quantity - price.resolvedQuantity;
          price._reservedQuantity = _reserved < 0 ? 0 : _reserved;
          ctrl.notice.hideErrorMessages();
        },

        onReservationError: function (message) {
          ctrl.notice.showErrorMessages([{ message: message }]);
        },

        validateTicket: function (ticket, eventId, ticketTypeId, orderItemId) {
          if (isNaN(parseInt(ticket.rebookQuantity, 10))) {
            ticket.resolvedQuantity = ticket.quantity;
            ticket.rebookQuantity = 0;
          } else {
            if (ticket.rebookQuantity > ticket.quantity) {
              ticket.resolvedQuantity = 0;
              ticket.rebookQuantity = ticket.quantity;
            } else if (ticket.rebookQuantity < 0) {
              ticket.resolvedQuantity = ticket.quantity;
              ticket.rebookQuantity = 0;
            } else {
              ticket.rebookQuantity = parseInt(ticket.rebookQuantity, 10);
              ticket.resolvedQuantity = ticket.quantity - ticket.rebookQuantity;
            }
          }

          if (ctrl.isInventoryItemType(ticket.itemType)) {
            ticket.rebookPrice =
              ticket.rebookQuantity *
              ctrl.rebookPersonTypes['item-' + eventId + '-' + ticketTypeId + '-' + orderItemId].price; //ctrl.rebookPersonTypes['item-' + eventId + '-' + ticketTypeId + '-' + orderItemId]
          } else {
            if (ctrl.isDiscounted) {
              ticket.rebookPrice =
                ticket.rebookQuantity *
                ctrl.rebookPersonTypes['item-' + eventId + '-' + ticketTypeId + '-' + orderItemId].discountedPrice;
            } else {
              ticket.rebookPrice =
                ticket.rebookQuantity *
                ctrl.rebookPersonTypes['item-' + eventId + '-' + ticketTypeId + '-' + orderItemId].price;
            }
          }

          if (ctrl.autoFee[eventId]) {
            ctrl.applyAutoFees();
          } else {
            ctrl.applyFees(eventId);
          }
        },

        getIntegerAmount: function (amount) {
          var numAmount = HelpersService.currencyFloatToInteger(amount);
          return HelpersService.integerToCurrencyFloat(Math.abs(numAmount));
        },

        findOrderEventSalesChannelsById: function (orderEvents, eventId, itemTypeId, isTypeTicket) {
          let r: TODO = false;

          for (let i = 0, ii = orderEvents.length; i < ii && !(r instanceof Array); i++) {
            if (orderEvents[i].id === eventId) {
              if (isTypeTicket) {
                for (let j = 0, jj = orderEvents[i].priceList.prices.length; j < jj; j++) {
                  //intentionally using == here and not ===
                  if (orderEvents[i].priceList.prices[j].personType.id == itemTypeId) {
                    r = orderEvents[i].priceList.prices[j].salesChannels;
                    break;
                  }
                }
              } else {
                if (orderEvents[i].addOns) {
                  for (let j = 0, jj = orderEvents[i].addOns.inventoryAddOns.length; j < jj; j++) {
                    //intentionally using == here and not ===
                    if (orderEvents[i].addOns.inventoryAddOns[j].id == itemTypeId) {
                      r = orderEvents[i].addOns.inventoryAddOns[j].salesChannels;
                      break;
                    }
                  }
                }
              }
            }
          }

          return r || [];
        },

        processOrder: function (orderEvents) {
          ctrl.currentOrder = $scope.programsListAdminBooking.processOrderEvents(ctrl.order, orderEvents);
          ctrl.model.orderId = ctrl.order.orderId;
          ctrl.orderLoading = false;
          ctrl.getRebookFees();
        },

        processOrderEvents: function (order, orderEvents) {
          let prices = [];
          let eventPriceList = [];
          let addOns = [];
          let orderEvent;
          let orderEventItem;

          for (let i = 0, ii = order.eventItems.length; i < ii; i++) {
            orderEvent = order.eventItems[i];

            if (!ctrl.enableCSRToggle) {
              orderEvent.toggleCSRPrices = true;
              orderEvent.toggleCSRAddons = true;
            }

            eventPriceList = (orderEvent.toggleCSRPrices ? ctrl.event.allPrices : ctrl.event.csrPrices) || [];
            addOns = (orderEvent.toggleCSRAddons ? ctrl.event.allAddons : ctrl.event.csrAddons) || [];

            if (orderEvent.eventDate) {
              orderEvent.startDate = $filter('date')(CalendarService.parseDate(orderEvent.eventDate), ctrl.dateFormat);
              orderEvent.startHour = $filter('date')(CalendarService.parseDate(orderEvent.eventDate), ctrl.hourFormat);
            } else {
              orderEvent.startDate = 'Date N/A';
              orderEvent.startHour = 'Time N/A';
            }

            if (order.eventItems[i].state && order.eventItems[i].state === 'cancelled') {
              order.eventItems[i].isCancelled = true;
              order.eventItems[i].formattedCancellationDate = $filter('date')(
                order.eventItems[i].cancellationDate,
                HelpersService.dateFormats.standardDateTime
              );
            } else {
              order.eventItems[i].isCancelled = false;
              order.eventItems[i].formattedCancellationDate = '';
            }

            // Need to store event id's to fetch the rebook fees later
            // Referenced in getRebookFees()
            if (!ctrl.orderEvents[orderEvent.eventId]) {
              ctrl.orderEvents[orderEvent.eventId] = true;
            }
            if (!ctrl.autoFee[orderEvent.eventId]) {
              ctrl.autoFee[orderEvent.eventId] = true;
            }
            for (let j = 0, jj = orderEvent.items.length; j < jj; j++) {
              orderEventItem = orderEvent.items[j];
              orderEventItem.rebookQuantity = 0;
              orderEventItem.resolvedQuantity = orderEventItem.quantity;

              if (ctrl.isEventItemType(orderEventItem.itemType)) {
                orderEventItem.allPrices = ctrl.getRebookPrices(
                  orderEventItem,
                  'item-' + orderEvent.eventId + '-' + orderEventItem.itemTypeId + '-' + orderEventItem.orderItemId,
                  angular.copy(ctrl.event.allPrices)
                );
                orderEventItem.csrPrices = ctrl.getRebookPrices(
                  orderEventItem,
                  'item-' + orderEvent.eventId + '-' + orderEventItem.itemTypeId + '-' + orderEventItem.orderItemId,
                  angular.copy(ctrl.event.csrPrices)
                );
                prices =
                  (orderEvent.toggleCSRPrices ? orderEventItem.allPrices : orderEventItem.csrPrices) ||
                  eventPriceList ||
                  [];
                ctrl.rebookPersonTypes[
                  'item-' + orderEvent.eventId + '-' + orderEventItem.itemTypeId + '-' + orderEventItem.orderItemId
                ] = prices[ctrl.findEventPersonType(orderEventItem.itemTypeName, prices)];
                orderEventItem.salesChannels = ctrl.findOrderEventSalesChannelsById(
                  orderEvents,
                  orderEvent.eventId,
                  orderEventItem.itemTypeId,
                  true
                );
              } else if (ctrl.isInventoryItemType(orderEventItem.itemType)) {
                if (ctrl.eventHasAddOns()) {
                  ctrl.rebookPersonTypes[
                    'item-' + orderEvent.eventId + '-' + orderEventItem.itemTypeId + '-' + orderEventItem.orderItemId
                  ] = addOns[ctrl.findEventInventoryType(orderEventItem.itemTypeName, addOns)];
                  orderEventItem.salesChannels = ctrl.findOrderEventSalesChannelsById(
                    orderEvents,
                    orderEvent.eventId,
                    orderEventItem.itemTypeId,
                    false
                  );
                } else {
                  ctrl.rebookPersonTypes[
                    'item-' + orderEvent.eventId + '-' + orderEventItem.itemTypeId + '-' + orderEventItem.orderItemId
                  ] = false;
                  orderEventItem.salesChannels = [];
                }
              } else {
                orderEventItem.salesChannels = [];
              }
            }
          }

          return order;
        },

        getRebookPrices: function (ticket, price, prices) {
          if (prices && prices.length) {
            prices.forEach(function (item) {
              if (item.personType.id === ticket.itemTypeId) {
                if (!ticket.hasOwnProperty('discountId')) {
                  item.discountedPrice = item.price;
                  item.discount = 0;
                }
              }
            });
          }
          return prices;
        },

        process: function (event) {
          event.startDate = $filter('date')(CalendarService.parseDate(event.startTime), ctrl.dateFormat);
          event.startHour = $filter('date')(CalendarService.parseDate(event.startTime), ctrl.hourFormat);

          for (let i = 0, ii = event.salesChannels.length; i < ii; i++) {
            ctrl.salesChannels[event.salesChannels[i].channel] = event.salesChannels[i].enabled ? 'Yes' : 'No';
          }

          if (event.state && event.state === 'cancelled') {
            event.isCancelled = true;
            event.formattedCancellationDate = $filter('date')(
              event.cancellationDate,
              HelpersService.dateFormats.standardDateTime
            );
          } else {
            event.isCancelled = false;
            event.formattedCancellationDate = '';
          }

          if (event.priceList && event.priceList.hasOwnProperty('prices')) {
            event.csrPrices = ctrl.enableCSRToggle
              ? ctrl.getPricesForEvent(event.priceList.prices, false)
              : event.priceList.prices;
            event.allPrices = ctrl.enableCSRToggle
              ? ctrl.getPricesForEvent(event.priceList.prices, true)
              : event.priceList.prices;
          } else {
            event.csrPrices = [];
            event.allPrices = [];
          }

          if (event.addOns && event.addOns.hasOwnProperty('inventoryAddOns')) {
            event.csrAddons = ctrl.enableCSRToggle
              ? ctrl.getAddOnsForEvent(event.addOns.inventoryAddOns, false)
              : event.addOns.inventoryAddOns;
            event.allAddons = ctrl.enableCSRToggle
              ? ctrl.getAddOnsForEvent(event.addOns.inventoryAddOns, true)
              : event.addOns.inventoryAddOns;
          } else {
            event.csrAddons = [];
            event.allAddons = [];
          }

          return event;
        },

        processEventCoupons: function (list) {
          const items: TODO[] = [];
          const filterDiscountedItems = (items) => {
            return items.eventPriceLists[0].priceList.discountPriceListEntries.filter((item) => {
              var discountValue = HelpersService.currencyFloatToInteger(item.discountValue, 2);
              return discountValue > 0;
            });
          };

          for (let i = 0, ii = list.length; i < ii; i++) {
            items.push({
              couponCode: list[i].couponCode,
              priceList: filterDiscountedItems(list[i]),
            });
          }

          if (items.length) {
            ctrl.isDiscounted = true;
          }

          return items;
        },

        processComplete: function () {
          ctrl.model.rebookItems = [];
          ctrl.model.eventRebookFeeCounts = [];
          ctrl.updateRebookItems();

          ctrl.setEmailOption();

          if (ctrl.model.payment && ctrl.model.payment.contactEmail) {
            ctrl.model.email = ctrl.model.payment.contactEmail;
          }

          if (ctrl.model.payment && ctrl.model.payment.address) {
            ctrl.model.address = ctrl.model.payment.address;
          }

          for (const item in ctrl.rebookItems) {
            if (ctrl.rebookItems.hasOwnProperty(item)) {
              ctrl.model.rebookItems.push($.extend({}, ctrl.rebookItems[item]));
            }
          }
          for (const eventId in ctrl.eventRebookFees) {
            if (ctrl.eventRebookFees.hasOwnProperty(eventId)) {
              ctrl.model.eventRebookFeeCounts.push({
                eventId: eventId,
                count: ctrl.eventRebookFees[eventId].quantity,
              });
            }
          }
        },

        processPayment: function () {
          // Only validate if there is a payment amount
          ctrl.isProcessing = true;
          if (ctrl.summary.currentOrderBalance > 0) {
            // Send message to payment directive to process order
            ctrl.validateEmail = parseInt(ctrl.emailOption, 10) === 0 ? false : true;
            $scope.$broadcast('Payment::Process', { validateEmail: ctrl.validateEmail });
            ctrl.processPaymentErrors();
          } else {
            ctrl.model.payment = null;
            ctrl.complete();
          }
        },

        getPricesForEvent: function (prices, toggleCSRPrices) {
          var r;
          if (!toggleCSRPrices) {
            r = $filter('saleChannel' as TODO)(prices, 'customerRep');
          } else {
            r = $filter('saleChannel' as TODO)(prices, 'customerRep').concat(
              $filter('saleChannel' as TODO)(prices, '!customerRep')
            );
          }

          return r;
        },

        getAddOnsForEvent: function (addOns, toggleCSRAddons) {
          let r: TODO[] = [];
          if (!toggleCSRAddons) {
            r = $filter('saleChannel' as TODO)(addOns, 'customerRep');
          } else {
            r = $filter('saleChannel' as TODO)(addOns, 'customerRep').concat(
              $filter('saleChannel' as TODO)(addOns, '!customerRep')
            );
          }

          return r;
        },

        resetNonCSRItems: function (event, isEvent) {
          isEvent = isEvent || false;

          const nonCsrItems: TODO[] = $filter('saleChannel' as TODO)(event.items, '!customerRep');
          const csrItems: TODO[] = $filter('saleChannel' as TODO)(event.items, 'customerRep');
          let found = false;

          //reset quantity
          for (let i = 0, ii = nonCsrItems.length; i < ii; i++) {
            if (ctrl.isEventItemType(nonCsrItems[i].itemType) === isEvent) {
              nonCsrItems[i].resolvedQuantity = nonCsrItems[i].quantity;
              nonCsrItems[i].rebookQuantity = 0;
            }
          }
          for (let i = 0, ii = csrItems.length; i < ii; i++) {
            if (csrItems[i].rebookQuantity > 0) {
              const type = 'item-' + event.eventId + '-' + csrItems[i].itemTypeId + '-' + csrItems[i].orderItemId;
              if (ctrl.rebookPersonTypes.hasOwnProperty(type)) {
                if (ctrl.isEventItemType(csrItems[i].itemType)) {
                  for (let j = 0, jj = ctrl.event.csrPrices.length; j < jj; j++) {
                    if (ctrl.event.csrPrices[j].personType.id === ctrl.rebookPersonTypes[type].personType.id) {
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    ctrl.rebookPersonTypes[type] = ctrl.event.csrPrices[0];
                    csrItems[i].resolvedQuantity = csrItems[i].quantity;
                    csrItems[i].rebookQuantity = 0;
                  }
                } else {
                  for (let j = 0, jj = ctrl.event.csrAddons.length; j < jj; j++) {
                    if (ctrl.event.csrAddons[j].id === ctrl.rebookPersonTypes[type].id) {
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    ctrl.rebookPersonTypes[type] = ctrl.event.csrAddons[0];
                    csrItems[i].resolvedQuantity = csrItems[i].quantity;
                    csrItems[i].rebookQuantity = 0;
                  }
                }
              }
            }
          }
        },

        resetEventItems: function (event) {
          event.items.forEach(function (item) {
            var dropdown = 'item-' + event.eventId + '-' + item.itemTypeId + '-' + item.orderItemId;
            var prices = event.toggleCSRPrices ? item.allPrices : item.csrPrices;
            var currentValue = ctrl.rebookPersonTypes[dropdown];

            var newValueIndex = prices.findIndex(function (price) {
              return currentValue.personType.id === price.personType.id;
            });

            if (newValueIndex < 0) {
              newValueIndex = 0;
            }

            ctrl.rebookPersonTypes[dropdown] = prices[newValueIndex];
          });
        },

        togglePrices: function (event) {
          event.toggleCSRPrices = !event.toggleCSRPrices;

          if (ctrl.isMode('booking')) {
            ctrl.resetEventItems(event);

            if (!event.toggleCSRPrices) {
              ctrl.resetNonCSRItems(event, true);
            }
          }
        },

        toggleAddons: function (event) {
          event.toggleCSRAddons = !event.toggleCSRAddons;

          if (ctrl.isMode('booking')) {
            if (!event.toggleCSRAddons) {
              ctrl.resetNonCSRItems(event, false);
            }
          }
        },

        refreshAvailableTicketsQuantity: function (event) {
          var reservedQuantity = 0;

          reservedQuantity = ctrl.currentOrder.eventItems.reduce(function (result, event) {
            var items = event.items || [];

            return (
              result +
              items.reduce(function (sum, price) {
                return sum + (price._reservedQuantity || 0);
              }, 0)
            );
          }, 0);

          return ApiService.inventoryB2C.detail(event.id).then(function (eventSummary) {
            ctrl.event.soldQuantity = eventSummary.soldQuantity - reservedQuantity;
          });
        },

        selectEmailOption: function () {
          if (ctrl.model.noEmail) {
            ctrl.emailOption = '0';
          } else if (ctrl.model.sendEmailToAll) {
            ctrl.emailOption = '2';
          } else if (!ctrl.model.noEmail && !ctrl.model.sendEmailToAll) {
            ctrl.emailOption = '1';
          }
        },

        setEmailOption: function () {
          switch (parseInt(ctrl.emailOption, 10)) {
            case 0:
              ctrl.model.noEmail = true;
              ctrl.model.sendEmailToAll = false;
              break;
            case 1:
              ctrl.model.noEmail = false;
              ctrl.model.sendEmailToAll = false;
              break;
            case 2:
              ctrl.model.noEmail = false;
              ctrl.model.sendEmailToAll = true;
              break;
          }
        },

        back: function () {
          ctrl.mode = 'booking';
        },

        cancel: function () {
          $state.go('application.programs.list');
        },

        isMembershipConversion: function (ticket) {
          return ticket && ticket.conversionStatus && ticket.conversionStatus === 'MembershipConversion';
        },

        review: function () {
          ctrl.processComplete();

          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();

          ApiService.orders.booking.calculate(ctrl.model).then(ctrl.success.review, ctrl.error.review);
        },

        clearLoading() {
          ctrl.isProcessing = false;
        },

        shouldUseCORSCheckout() {
          return CheckoutProcessService.shouldUseCORSCheckout({ requiresCardData: ctrl.requiresCardData });
        },

        complete: function () {
          ctrl.processComplete();

          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();

          /**
           * This is order duplication prevention
           * We create the checkout UUID and tack it onto the checkout request
           * Only rewrite the requestUUID when there are no errors and a checkout has taken place
           * This will always be refreshed when the page is refreshed, but, in the context of an order
           * it should only be overwritten if it has been explicitly set to `false`
           */

          if (!ctrl.requestUUID) {
            ctrl.requestUUID = uuid2.newuuid();
          }

          if (ctrl.shouldUseCORSCheckout()) {
            const data: OrderBookingCreateData = CheckoutProcessService.processOrderBookingCreateData(
              {
                ...ctrl.model,
                requestUUID: ctrl.requestUUID,
              },
              { withCreditCardInfo: false }
            );
            CheckoutProcessService.handleACMEPaymentSessionRebookOrder(ctrl.processACMEPaymentData(data))
              .then((response) => ctrl.success.complete(response))
              .catch(async (response) => {
                if (isACMECORSCheckoutError(response)) {
                  switch (response.type) {
                    case 'sdk.render_failed': {
                      ctrl.clearLoading();

                      ctrl.error.complete({
                        status: 0,
                        data: { code: 0, errorCode: 0, error: response.params.message },
                      });
                      break;
                    }

                    case 'sdk.cancel_flow': {
                      ctrl.clearLoading();
                      break;
                    }

                    case 'sdk.billing_address.request_change': {
                      ctrl.clearLoading();
                      document.querySelector(`[data-testid="billing-address-anchor"]`)?.scrollIntoView();
                      break;
                    }

                    case 'api.error': {
                      ctrl.error.complete(CheckoutProcessService.mapToPaymentProcessError(response));
                      break;
                    }

                    default: {
                      console.warn(`unhandled`, response);

                      ctrl.clearLoading();
                      break;
                    }
                  }
                } else {
                  ctrl.error.complete(response);
                }
              });
          } else {
            const data: OrderBookingCreateData = CheckoutProcessService.processOrderBookingCreateData(
              {
                ...ctrl.model,
                requestUUID: ctrl.requestUUID,
              },
              { withCreditCardInfo: true }
            );

            ApiService.orders.booking
              .create(data)
              .then((response) => ctrl.success.complete(response))
              .catch((response) => ctrl.error.complete(response));
          }
        },

        processACMEPaymentData: function (data: OrderBookingCreateData): SecureOrderBookingCreateProps {
          const countryData = LocationService.findCountry({ country: data.billingCountry });
          const stateData = LocationService.findState({ state: data.billingState });
          const cssVarsData = CheckoutProcessService.getCORSCheckoutCSSVariables();
          const payment = CheckoutProcessService.getPaymentData();

          return {
            values: data,
            options: {
              formattedBillingAddress: addressService.formatAddress({
                streetAddress1: data.billingAddress1,
                streetAddress2: data.billingAddress2,
                country: countryData ? countryData.country.name : data.billingCountry,
                zipCode: data.billingZipCode,
                city: data.billingCity,
                state: stateData ? stateData.name : data.billingState,
              }),
              modal: {
                title: 'Payment',
                submit: 'Complete Order',
                close: 'Close',
              },
              authorizePayment: {
                paymentData: {
                  externalId: '',
                  chargeAmount: payment?.chargeAmount ?? ctrl.summary.currentOrderBalance,
                  firstName: payment?.contactFirstName || '',
                  lastName: payment?.contactLastName || '',
                  creditCardVerificationData: {
                    address1: data.billingAddress1,
                    address2: data.billingAddress2,
                    country: countryData ? String(countryData.country.numericCode) : data.billingCountry,
                    zipCode: data.billingZipCode,
                    city: data.billingCity,
                    state: stateData ? stateData.abbreviation : data.billingState,
                  },
                },
                saleChannel: PermissionsService.check('CSR') ? 'reseller' : 'insideSalesIndividual',
              },
              capturePayment: {
                loaderHtml: CheckoutProcessService.getCheckoutLoadingHtml(),
              },
              autorenew: {
                enabled: false,
                html: ThemesHelperService.getTextVariable('checkout-process-page-autorenew-message'),
                url: '',
              },
              terms: {
                html: ThemesHelperService.getHTMLVariable('checkout-process-page-terms'),
                url: '',
              },
              creditCardSettings: {
                supportedCardsText: ThemesHelperService.getTextVariable('checkout-supported-cards-text'),
                showVisaLogo: ThemesHelperService.getTextVariable('checkout-show-visa-logo'),
                showMcLogo: ThemesHelperService.getTextVariable('checkout-show-mc-logo'),
                showDiscoverLogo: ThemesHelperService.getTextVariable('checkout-show-discover-logo'),
                showAmexLogo: ThemesHelperService.getTextVariable('checkout-show-amex-logo'),
              },
              variables: cssVarsData,
            },
          };
        },

        processPaymentErrors: function () {
          var paymentErrors = ValidateService.getErrorHash();

          ctrl.hasEmailError = false;

          angular.forEach(paymentErrors, function (item, index: TODO) {
            if (index === 'payment-email') {
              ctrl.hasEmailError = true;
            }
          });
        },

        showEmailErrorMessage: function (emailOption) {
          return ctrl.hasEmailError && parseInt(ctrl.emailOption, 10) === parseInt(emailOption, 10);
        },

        success: {
          init: function (response) {
            ctrl.event = ctrl.process(response.data.payload);
            ctrl.getCouponsForEvent();
            ctrl.selectEmailOption();
          },

          review: function (response) {
            ctrl.summary = response.data.payload;
            ctrl.mode = 'payment';
          },

          complete: function (response) {
            ctrl.notice.showSuccessMessages([{ message: 'Successfully Saved!' }]);

            if ($scope.noticeTimer) {
              $timeout.cancel($scope.noticeTimer);
            }
            if ($scope.stateTimer) {
              $timeout.cancel($scope.stateTimer);
            }
            $scope.noticeTimer = $timeout(function () {
              ctrl.notice.hideSuccessMessages();
              ctrl.resetModel();
              $scope.$broadcast('Payment::Reset');
              $scope.stateTimer = $timeout(function () {
                $state.go('application.orders.detail.summary', { orderId: ctrl.currentOrder.orderId });
                /**
                 * State should have changed it is safe to restore on next tick
                 *   requestUUID: false
                 */
                // next tick
                $timeout(function () {
                  ctrl.requestUUID = false;
                }, 0);
              }, 300);
            }, 3000);
            ctrl.isProcessing = false;
          },

          searchOrders: function (response) {
            ctrl.orders = response.data.payload.list;
            ctrl.checkOrders();
            ctrl.ordersLoading = false;
          },

          getOrder: function (response) {
            ctrl.order = response.data.payload;

            if (response.data.payload.accountId) {
              ctrl.getAccountDiscountedEvent(response.data.payload.accountId);
              ctrl.getPayments(response.data.payload.accountId);
            } else if (response.data.payload.membershipId) {
              ctrl.getMembershipDiscountedEvent(response.data.payload.membershipId);
            } else {
              ctrl.isDiscounted = false;
              ctrl.getOrderEventDetails(ctrl.order.orderId);
            }
          },

          getRebookFees: function (response) {
            const fees = response.data.payload;

            for (let i = 0, ii = fees.length; i < ii; i++) {
              if (!fees[i].rebookingFee) {
                fees[i].rebookingFee = 0;
              }
              fees[i].quantity = 0;
              fees[i].total = 0;

              ctrl.eventRebookFees[fees[i].eventId] = fees[i];
            }
          },

          getDiscountedEvent: function (response) {
            ctrl.success.init(response);
            ctrl.getOrderEventDetails(ctrl.order.orderId);
          },

          getPayments: function (response) {
            ctrl.payment = response.data.payload;
          },

          getOrderEventDetails: function (response) {
            //process the order after getting the order event details
            ctrl.processOrder(response.data.payload);
          },

          getDuplicateOrder: function (response) {
            ctrl.success.complete(response);
          },

          getCouponsForEvent: function (response) {
            ctrl.event.coupons = ctrl.processEventCoupons(response.data.payload);
          },
        },

        error: {
          init: function (response) {},
          review: function (response) {},
          complete: function (response: { status: number; data: PaymentProcessError }) {
            if (response.status === 409 && response.data.errorCode === 20152) {
              ctrl.getDuplicateOrder();
            } else {
              ctrl.isProcessing = false;

              $scope.$broadcast('Payment::Process::Error', { response: response });

              const messages = response.data.errors
                ? response.data.errors.map((error) => ({ message: error.message.replace(/^.*?:/, '') }))
                : [{ message: response.data.error.replace(/^.*?:/, '') }];

              ctrl.notice.showErrorMessages(messages);
            }
          },
          searchOrders: function (response) {
            $scope.programsListAdminBooking.ordersLoading = false;
          },
          getOrder: function (response) {
            $scope.programsListAdminBooking.orderLoading = false;
          },
          getRebookFees: function (response) {},
          getDiscountedEvent: function (response) {
            $scope.programsListAdminBooking.error.init(response);
          },
          getPayments: function (response) {
            $scope.programsListAdminBooking.payment = {};
          },
          getOrderEventDetails: function (response) {
            ctrl.processOrder([]);
          },
          getDuplicateOrder: function (response) {
            ctrl.error.complete(response);
          },
          getCouponsForEvent: function () {},
        },

        onPaymentComplete: function (e, data) {
          ctrl.model.payment = data;
          CheckoutProcessService.setPaymentData(data);
          if (ctrl.model.payment.contactFirstName) {
            ctrl.model.payment.firstName = ctrl.model.payment.contactFirstName;
          }
          if (ctrl.model.payment.contactLastName) {
            ctrl.model.payment.lastName = ctrl.model.payment.contactLastName;
          }

          ctrl.complete();
        },
        onPaymentError: function (e, data) {
          ctrl.isProcessing = false;
          $scope.programsListAdminBooking.notice.showErrorMessages([{ message: data }]);
          $scope.noticeTimer = $timeout(function () {
            ctrl.notice.hideSuccessMessages();
          }, 3000);
        },
      };

      $scope.programsListAdminBooking = ctrl;
      ctrl.init();
    },
  ]).name;
